import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  RATING_ACTIVE_START,
  RATING_INACTIVE_START,
} from '../../constants';

const StarRating = ({
  name,
  className,
  change,
  editing,
  value,
  starCount
}) => {
  const [rating, setRating] = useState(0);

  const onStarClick = (nextValue) => {
    setRating(nextValue);
    change(nextValue);
  }

  return (
    <div className={className}>
      {Array.from({ length: starCount ? starCount : 1 }, (elem, index) => {
        return (
          <React.Fragment key={index}>
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 12 12" fill="none" onClick={() => editing ? onStarClick(index + 1) : null}>
              <g clipPath="url(#clip0_8_140)">
                <path d="M11.565 4.8C11.565 4.9 11.515 5.01 11.415 5.13L8.985 7.5L9.555 10.86C9.555 10.88 9.555 10.92 9.555 10.98C9.555 11.08 9.535 11.16 9.495 11.22C9.455 11.28 9.385 11.31 9.285 11.31C9.205 11.31 9.115 11.29 9.015 11.25L6.015 9.66L3.015 11.25C2.915 11.29 2.825 11.31 2.745 11.31C2.645 11.31 2.575 11.28 2.535 11.22C2.495 11.16 2.465 11.08 2.445 10.98C2.445 10.96 2.455 10.92 2.475 10.86L3.045 7.5L0.614998 5.13C0.494998 5.01 0.434998 4.9 0.434998 4.8C0.434998 4.64 0.564998 4.54 0.824998 4.5L4.185 4.02L5.685 0.960002C5.765 0.780002 5.875 0.690002 6.015 0.690002C6.155 0.690002 6.265 0.780002 6.345 0.960002L7.845 4.02L11.205 4.5C11.445 4.54 11.565 4.64 11.565 4.8Z" fill={(editing ? rating : value) > index ? RATING_ACTIVE_START : (starCount ? RATING_INACTIVE_START : RATING_ACTIVE_START)} />
              </g>
              <defs>
                <clipPath id="clip0_8_140">
                  <rect width="1em" height="1em" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </React.Fragment>
        )
      })}
    </div>
  );
};

StarRating.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  change: PropTypes.any,
  editing: PropTypes.bool,
  value: PropTypes.number
};

StarRating.defaultProps = {
  editing: false,
  value: 0
};

export default StarRating;